export default __webpack_public_path__ + "static/media/elecbitsLogoWhite.1ef8b116.svg";